import React, { type CSSProperties, type PropsWithChildren } from 'react'
import classnames from 'classnames'

import './BadgeComponent.scss'

const OVERFLOW_COUNT = 99

type BadgeComponentProps = PropsWithChildren<{
  className?: string
  color?: string
  style?: CSSProperties
  count?: string | number
}>

const getDisplayCount = (count: BadgeComponentProps['count']) => {
  if (count === undefined || count === '') return null
  if (Number(count) === 0) return null
  if (Number(count) > OVERFLOW_COUNT) return `${OVERFLOW_COUNT}+`

  return String(count)
}

const BadgeComponent = ({
  className,
  color,
  style,
  count,
  children,
}: BadgeComponentProps) => {
  const displayCount = getDisplayCount(count)

  return (
    <div className="badge-component">
      <span className={classnames('badge-component-wrapper', className)}>
        {children}
        {displayCount && (
          <sup
            className={classnames('badge-component-count', {
              'multiple-words': displayCount.length > 1,
            })}
            style={{
              ...style,
              ...(color && {
                backgroundColor: color,
                boxShadow: `0 0 0 1px ${color}`,
              }),
            }}
          >
            {displayCount}
          </sup>
        )}
      </span>
    </div>
  )
}

export { BadgeComponent }
